// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"33bb19a8","36":"013b348f","89":"a4fd43f2","128":"c264140e","365":"aef3b9bb","576":"b2f8f996","661":"042c6efd","805":"f500f701","810":"65aa3e09","815":"e3f55d21","878":"5baa4064","906":"84359a88"}[chunkId] + ".chunk.js";
};